// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — rack-state-line.classic.js, новая — rack-state-line.cp.js
import { isCp } from 'libs/design';
import * as classic from './rack-state-line.classic';
import * as cp from './rack-state-line.cp';

export const RackStateLine = isCp ? cp.RackStateLine : classic.RackStateLine;
